<template>
    <div class="family-member__list">
        <div v-if="familyMembers.length > 1" class="family-member__field">
            <label for="mypage-member-select" class="family-member__label">Bruker</label>
            <select id="mypage-member-select" v-model="localMemberId" class="family-member__select">
                <option v-for="m in familyMembers" :key="m.id" :value="m.id">{{ m.name }}</option>
            </select>
        </div>
        <div class="family-member__field">
            <label for="mypage-year-select" class="family-member__label">Sesong</label>
            <select id="mypage-year-select" v-model="localCompetitionId" class="family-member__select">
                <option v-for="c in competitions" :key="c.id" :value="c.id">{{ c.name }}</option>
            </select>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    memberId: { type: Number, required: true },
    competitionId: { type: [Number, String], default: '' },
    familyMembers: { type: Array, default: () => [] },
    competitions: { type: Array, default: () => [] },
});

const emit = defineEmits(['update:memberId', 'update:competitionId']);

// Proxied through a computed rather than plain v-model props so the
// <select>'s own v-model keeps its usual behavior (the bound value keeps
// its original type - here numeric ids - rather than the stringified DOM
// value a plain @change handler would receive).
const localMemberId = computed({
    get: () => props.memberId,
    set: (value) => emit('update:memberId', value),
});

const localCompetitionId = computed({
    get: () => props.competitionId,
    set: (value) => emit('update:competitionId', value),
});
</script>
